module.exports = __webpack_public_path__ + "static/media/delete-dustbin-icon.ef3dac20.svg";